<template>
  <v-card-title style="text-align: start; white-space: break-spaces">
    {{ i18n.t('texts.access') }}
  </v-card-title>
  <v-card-text>
    <v-card
      v-for="service in userStore.services"
      :key="service.name + '_' + service.instance"
      style="margin-bottom: 4px"
      variant="elevated"
      :href="service.gui"
    >
      <v-card-text style="white-space: break-spaces">
        {{ service.name }} - {{ service.instance }}
      </v-card-text>
    </v-card>
  </v-card-text>
</template>

<script lang="ts" src="./SelectServiceForm.ts" />
